import { useEffect } from "react"
import { extractDate, mmddyyyy } from "@prescreen/lib/date-utils"
import * as Format from "@prescreen/lib/formats"
import { PrescreenRequest } from "@prescreen/lib/types/prescreen"
import { VITE_PREFILL_PHONE } from "@prescreen/lib/config"

export enum PrequalHelperVariant {
  PrimaryEligibility,
  CoborrowerEligibility,
  CoborrowerInfo
}

export const usePrequalPasteHelper = (
  update: (data: Partial<PrescreenRequest>) => void,
  variant?: PrequalHelperVariant
) => {
  const handlePaste = (event: ClipboardEvent) => {
    const text = event.clipboardData.getData("text")
    const parts = text.split("\t")
    if (parts.length === 12 && parts[4].match(/^666\d{6}$/)) {
      const address = {
        streetAddress: [parts[6], parts[7], parts[8]].join(' '),
        city: parts[9],
        state: parts[10],
        zip: parts[11],
        country: 'United States'
      }

      const data = {}
      if (variant === PrequalHelperVariant.CoborrowerEligibility) {
        Object.assign(data, {
          coFirstName: parts[0],
          coMiddleName: parts[1],
          coLastName: parts[2],
          coEmail: parts[3],
          coPhone: VITE_PREFILL_PHONE,
          coSsn: Format.social(parts[4]),
          coBorrowerAddress: address,
          coStatedGrossAnnualIncome: '$101,010',
          coBirthDate: mmddyyyy(extractDate(parts[5])),
        })
      } else {
        // we're pasting a test case
        Object.assign(data, {
          firstName: parts[0],
          middleName: parts[1],
          lastName: parts[2],
          ssn: Format.social(parts[4]),
          phoneNumber: VITE_PREFILL_PHONE,
          // email: parts[6],
          birthDate: mmddyyyy(extractDate(parts[5])),
        
          ...(variant === PrequalHelperVariant.PrimaryEligibility ? {
            installedAtDifferentLocation: 'yes',
            streetAddress: address
          } : { // CoborrowerInfo
            streetAddress: address,
          })
        })          
      }

      console.log('data', data)

      update(data)
    }
  }

  useEffect(() => {
    document.addEventListener("paste", handlePaste)
    return () => {
      document.removeEventListener("paste", handlePaste)
    }
  }, [])
}
